module.exports = __webpack_public_path__ + "static/media/zera_putting_box.30bcc3ff.png";